const getLatestCoordinates = ({ chargingpoint }) => {
  return chargingpoint.merged_attributes?.coordinates ?? chargingpoint?.coordinates
}

/**
 * Reposition a chargingpoint.
 *
 * Merged locations are rendered from merged_attributes.coordinates, so both fields need
 * to be kept in sync. Otherwise the marker stays behind on the merged position, while
 * only the underlying coordinates move.
 */
const setLatestCoordinates = ({ chargingpoint, coordinates }) => {
  chargingpoint.coordinates = coordinates

  if (chargingpoint.merged_attributes?.coordinates) {
    chargingpoint.merged_attributes.coordinates = coordinates
  }

  return chargingpoint
}

module.exports = {
 getLatestCoordinates,
 setLatestCoordinates,
}
